// extracted by mini-css-extract-plugin
module.exports = {"responsive-image":"ResponsiveImage_responsive-image__FSSGb","responsiveImage":"ResponsiveImage_responsive-image__FSSGb"};